import React, { FC, memo } from 'react';
import { Link } from '@montana/shared/link';
import { useSiteStructure } from '@montana/containers/site-structure';
import { ILink } from '@montana/models/generated/cms.interface';
import { AnimatePresence, motion } from 'framer-motion';
import { Container } from '@montana/shared/container';
import { Transition } from 'framer-motion';


export interface IUspMenuProps {
    hide?: boolean;
}

const transition: Transition = {
    type: 'spring',
    stiffness: 500,
    damping: 50,
}

export const UspMenu: FC<IUspMenuProps> = memo(({ hide }: IUspMenuProps) => {
    const { usPs } = useSiteStructure();

    return (
        <AnimatePresence>
            {
                usPs && !hide &&
                <motion.aside
                    initial={{ y: '-100%' }}
                    animate={{ y: '0%' }}
                    exit={{ y: '-100%' }}
                    transition={transition}
                    className="usp-menu"
                >
                    <motion.div
                        initial={{ y: '100%' }}
                        animate={{ y: '0%' }}
                        exit={{ y: '100%' }}
                        transition={transition}
                        className="usp-menu__inner"
                    >
                        <Container className={`usp-menu__content ${usPs.length === 1 ? "justify-center" : "justify-between"}`}>
                            {usPs.map((uspLink: ILink, index: number) =>
                                <div className="usp-menu__part"
                                    key={`usp-menu__link-${index}`}
                                >
                                    <Link
                                        className="usp-menu__link"
                                        to={uspLink.url}
                                        target={uspLink.target}
                                        withStroke
                                        inverseStrokeAnimation
                                    >
                                        {uspLink.name}
                                    </Link>
                                </div>
                            )}
                        </Container>
                    </motion.div>
                </motion.aside>
            }
        </AnimatePresence>
    );
});
